module.exports = __webpack_public_path__ + "img/3x.3e7b59f.jpg";